import React from 'react';
import PropTypes from 'prop-types';
import { EmailIcon } from '@domain-group/fe-co-icon';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import * as styles from './contact-buttons.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ContactButtons = _ref => {
  var phone = _ref.phone,
    emailContactable = _ref.emailContactable,
    launchEnquiryModal = _ref.launchEnquiryModal;
  return ___EmotionJSX("div", {
    css: styles.buttonGroup
  }, emailContactable && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: launchEnquiryModal,
    css: styles.cardButton,
    appearance: "primary",
    size: "small"
  }, "Email")), phone && ___EmotionJSX(CallButton, {
    phone: phone,
    css: styles.cardCallButton
  }));
};
ContactButtons.propTypes = {
  emailContactable: PropTypes.bool.isRequired,
  phone: PropTypes.string,
  launchEnquiryModal: PropTypes.func.isRequired
};
ContactButtons.defaultProps = {
  phone: undefined
};
export default ContactButtons;